export const bridgeTypes = [
  {
    id: 'warren',
    name: 'Warren Truss',
    description: 'Diagonal members alternate between compression and tension',
    image: 'https://via.placeholder.com/300x200/1e40af/ffffff?text=Warren+Truss',
    priceMultiplier: 1.0,
    complexityFactor: 1.0
  },
  {
    id: 'pratt',
    name: 'Pratt Truss',
    description: 'Vertical members in compression, diagonals in tension',
    image: 'https://via.placeholder.com/300x200/3b82f6/ffffff?text=Pratt+Truss',
    priceMultiplier: 1.1,
    complexityFactor: 1.1
  },
  {
    id: 'long',
    name: 'Long Truss',
    description: 'Extended span with additional support members',
    image: 'https://via.placeholder.com/300x200/1e40af/ffffff?text=Long+Truss',
    priceMultiplier: 1.3,
    complexityFactor: 1.4
  },
  {
    id: 'modular',
    name: 'Modular',
    description: 'Prefabricated sections for quick assembly',
    image: 'https://via.placeholder.com/300x200/3b82f6/ffffff?text=Modular',
    priceMultiplier: 0.9,
    complexityFactor: 0.8
  }
];

export const structuralMaterials = [
  {
    id: 'steel',
    name: 'Steel',
    properties: { strength: 'High', weight: 'Heavy', cost: 'High' },
    color: '#8B8B8B',
    basePricePerFoot: 850,
    materialMultiplier: 1.0
  },
  {
    id: 'concrete',
    name: 'Concrete',
    properties: { strength: 'High', weight: 'Very Heavy', cost: 'Medium' },
    color: '#A0A0A0',
    basePricePerFoot: 650,
    materialMultiplier: 0.8
  },
  {
    id: 'wood',
    name: 'Wood',
    properties: { strength: 'Medium', weight: 'Light', cost: 'Low' },
    color: '#8B4513',
    basePricePerFoot: 420,
    materialMultiplier: 0.5
  }
];

export const railingOptions = [
  {
    id: 'cable',
    name: 'Cable Railing',
    description: 'Modern steel cable design',
    color: '#404040',
    pricePerFoot: 85
  },
  {
    id: 'vertical',
    name: 'Vertical Pickets',
    description: 'Traditional vertical bar design',
    color: '#505050',
    pricePerFoot: 95
  },
  {
    id: 'horizontal',
    name: 'Horizontal Rails',
    description: 'Clean horizontal line design',
    color: '#606060',
    pricePerFoot: 75
  },
  {
    id: 'glass',
    name: 'Glass Panels',
    description: 'Transparent safety panels',
    color: '#E0E0E0',
    pricePerFoot: 165
  }
];

export const deckingOptions = [
  {
    id: 'concrete',
    name: 'Concrete Deck',
    description: 'Durable concrete surface',
    color: '#B0B0B0',
    pricePerFoot: 120
  },
  {
    id: 'asphalt',
    name: 'Asphalt',
    description: 'Smooth road surface',
    color: '#2C2C2C',
    pricePerFoot: 85
  },
  {
    id: 'wood',
    name: 'Wood Planking',
    description: 'Natural wood pedestrian surface',
    color: '#8B4513',
    pricePerFoot: 95
  },
  {
    id: 'steel',
    name: 'Steel Grating',
    description: 'Industrial steel mesh',
    color: '#708090',
    pricePerFoot: 145
  }
];

export const addOnOptions = [
  {
    id: 'led-lighting',
    name: 'LED Lighting',
    description: 'Energy-efficient LED strip lighting',
    icon: 'lightbulb',
    flatCost: 2500
  },
  {
    id: 'safety-barriers',
    name: 'Safety Barriers',
    description: 'Additional safety barriers',
    icon: 'shield',
    pricePerFoot: 45
  },
  {
    id: 'weather-protection',
    name: 'Weather Protection',
    description: 'Canopy or windscreen',
    icon: 'cloud',
    pricePerFoot: 125
  },
  {
    id: 'monitoring-system',
    name: 'Monitoring System',
    description: 'Structural health monitoring sensors',
    icon: 'activity',
    flatCost: 8500
  }
];

// NEW: Sub-modifier option catalogs
export const coatingOptions = [
  { id: 'galvanized', name: 'Galvanized', multiplier: 1.08 },
  { id: 'painted', name: 'Painted', multiplier: 1.03 },
  { id: 'powder', name: 'Powder-Coated', multiplier: 1.12 },
  { id: 'weathering', name: 'Weathering Steel', multiplier: 0.98 }
];

export const woodTypeOptions = [
  { id: 'pine', name: 'Pressure-Treated Pine', deckingMultiplier: 1.0 },
  { id: 'cedar', name: 'Cedar', deckingMultiplier: 1.15 },
  { id: 'ipe', name: 'Ipe Hardwood', deckingMultiplier: 1.6 },
  { id: 'composite', name: 'Composite', deckingMultiplier: 1.35 }
];

export const concreteAdderOptions = [
  { id: 'glowstones', name: 'Glowstones', costPerSqFt: 6 },
  { id: 'stamping', name: 'Stamping', costPerSqFt: 4 },
  { id: 'fiber', name: 'Fiber Reinforcement', costPerSqFt: 3 }
];

export const steelDecorOptions = [
  { id: 'finials', name: 'Arch Finials', flatCost: 1200 },
  { id: 'lattice', name: 'Decorative Lattice', pricePerFoot: 20 },
  { id: 'nameplate', name: 'Nameplate', flatCost: 900 }
];

export const loadRatingOptions = [
  { id: '10k', name: '10,000 lb' },
  { id: '25k', name: '25,000 lb' },
  { id: 'cl625', name: 'CL-625 Truck' },
  { id: '126k', name: '126,000 lb' }
];

export const picketStyleOptions = [
  { id: 'standard', name: 'Standard', multiplier: 1.0 },
  { id: 'spear-top', name: 'Spear-Top', multiplier: 1.1 },
  { id: 'square-twist', name: 'Square Twist', multiplier: 1.15 }
];

export const wingwallOptions = [
  { id: 'none', name: 'None' },
  { id: 'concrete-angled', name: 'Concrete Wingwalls', flatCostPerFootWidth: 150 },
  { id: 'stone', name: 'Stone Wingwalls', flatCostPerFootWidth: 220 },
  { id: 'steel-sheet', name: 'Steel Sheet Pile', flatCostPerFootWidth: 180 }
];

// expose load options for simple UI display (avoid prop drilling)
if (typeof window !== 'undefined') {
  window.__LR__ = [
    { id: '10k', name: '10,000 lb' },
    { id: '25k', name: '25,000 lb' },
    { id: 'cl625', name: 'CL-625 Truck' },
    { id: '126k', name: '126,000 lb' }
  ];
}

export const defaultConfiguration = {
  trussType: 'warren',
  material: 'steel',
  railing: 'cable',
  decking: 'concrete',
  addOns: [],
  length: 50, // Default length in feet
  width: 12,  // Default width in feet
  camber: 0,   // Default camber in inches (0 = flat, positive = arch up)
  // NEW: Sub-modifiers
  subModifiers: {
    coating: 'galvanized',
    woodType: 'pine',
    concreteAdders: { glowstones: false, stamping: false, fiber: false },
    steelDecor: [],
    picketStyle: 'standard',
    wingwalls: 'none',
    wingwallRailings: false,
    wingwallLengthFt: null,
    loadRating: '10k'
  }
};

// Pricing calculation utilities
export const calculateBridgePrice = (configuration) => {
  const { trussType, material, railing, decking, addOns, length, width, camber, subModifiers } = configuration;
  
  // Get base components
  const trussData = bridgeTypes.find(t => t.id === trussType);
  const materialData = structuralMaterials.find(m => m.id === material);
  const railingData = railingOptions.find(r => r.id === railing);
  const deckingData = deckingOptions.find(d => d.id === decking);
  
  // Calculate bridge area for deck and structural calculations
  const bridgeArea = length * width; // square feet
  
  // Camber complexity factor (increases cost for curved construction)
  const camberFactor = 1 + (Math.abs(camber) / 12) * 0.15; // 15% increase per foot of camber

  // Coating factor
  const coating = coatingOptions.find(c => c.id === (subModifiers?.coating || 'galvanized')) || coatingOptions[0];
  const coatingFactor = coating.multiplier || 1.0;
  
  // Base structural cost (affected by both length and width and camber and coating)
  // Provisional load rating multiplier (placeholder, to be provided by engineering later)
  const loadMultiplierMap = {
    '10k': 1.00,
    '25k': 1.06,
    'cl625': 1.15,
    '126k': 1.25
  };
  const loadMult = loadMultiplierMap[(subModifiers?.loadRating) || '10k'] || 1.0;

  const baseCost = materialData.basePricePerFoot * length * trussData.priceMultiplier * (1 + (width - 12) * 0.05) * camberFactor * coatingFactor * loadMult;
  
  // Railing cost (perimeter - both sides plus ends if width > 8ft)
  const railingPerimeter = (length * 2) + (width > 8 ? width * 2 : 0);
  let railingCost = railingData.pricePerFoot * railingPerimeter * (camber !== 0 ? 1.1 : 1); // 10% more for curved railings
  // Fancy pickets multiplier if vertical style selected
  if (railing === 'vertical') {
    const picket = picketStyleOptions.find(p => p.id === (subModifiers?.picketStyle || 'standard')) || picketStyleOptions[0];
    railingCost *= picket.multiplier || 1.0;
  }
  
  // Decking cost (area-based with camber complexity)
  let deckingCost = deckingData.pricePerFoot * bridgeArea * 0.1 * camberFactor;
  // Wood type modifier when decking is wood
  if (decking === 'wood') {
    const woodType = woodTypeOptions.find(w => w.id === (subModifiers?.woodType || 'pine')) || woodTypeOptions[0];
    deckingCost *= woodType.deckingMultiplier || 1.0;
  }
  // Concrete adders (only when concrete deck)
  if (decking === 'concrete' && subModifiers?.concreteAdders) {
    for (const adder of concreteAdderOptions) {
      if (subModifiers.concreteAdders[adder.id]) {
        deckingCost += adder.costPerSqFt * bridgeArea;
      }
    }
  }
  
  // Add-ons cost (existing)
  let addOnsCost = 0;
  addOns.forEach(addonId => {
    const addon = addOnOptions.find(a => a.id === addonId);
    if (addon) {
      if (addon.flatCost) {
        addOnsCost += addon.flatCost;
      } else if (addon.pricePerFoot) {
        addOnsCost += addon.pricePerFoot * length;
      }
    }
  });

  // Decorative steel add-ons pricing
  if (subModifiers?.steelDecor && subModifiers.steelDecor.length) {
    subModifiers.steelDecor.forEach(id => {
      const decor = steelDecorOptions.find(s => s.id === id);
      if (!decor) return;
      if (decor.flatCost) addOnsCost += decor.flatCost;
      if (decor.pricePerFoot) addOnsCost += decor.pricePerFoot * length;
    });
  }

  // Wingwalls pricing (based on width, both ends)
  if (subModifiers?.wingwalls && subModifiers.wingwalls !== 'none') {
    const ww = wingwallOptions.find(w => w.id === subModifiers.wingwalls);
    if (ww && ww.flatCostPerFootWidth) {
      addOnsCost += ww.flatCostPerFootWidth * width * 2; // both abutments
    }
    // Wingwall railings (rough): $60/ft along 4 walls, each wall length ~ min(width+6, 24)
    if (subModifiers?.wingwallRailings) {
      const wallLen = subModifiers?.wingwallLengthFt ? subModifiers.wingwallLengthFt : Math.min(width + 6, 24);
      addOnsCost += 60 * (wallLen * 4);
    }
  }
  
  const subtotal = baseCost + railingCost + deckingCost + addOnsCost;
  
  // Add engineering and installation (25% markup, higher for camber)
  const engineeringMultiplier = camber !== 0 ? 0.30 : 0.25; // 30% for cambered bridges
  const engineeringAndInstallation = subtotal * engineeringMultiplier;
  
  const total = subtotal + engineeringAndInstallation;
  
  return {
    baseCost,
    railingCost,
    deckingCost,
    addOnsCost,
    engineeringAndInstallation,
    subtotal,
    total,
    bridgeArea,
    railingPerimeter,
    camberFactor,
    coatingFactor,
    loadMult,
    priceRange: {
      low: total * 0.85, // 15% below estimate
      high: total * 1.25  // 25% above estimate
    }
  };
};

// NEW: Rough bridge weight guesstimator (very approximate)
export const calculateBridgeWeight = (configuration) => {
  const { length, width, material, decking, railing, addOns, subModifiers } = configuration;
  const area = length * width; // sq ft

  // Structural base psf-equivalent (represents truss + stringers, etc.) per plan area
  // Tunable constant for steel warren truss baseline
  const STRUCTURE_BASE_PSF = 80; // lb per sq ft of plan area (reduced rough guess)
  const materialFactor = {
    steel: 1.0,
    wood: 0.4,
    concrete: 1.3,
  }[material] || 1.0;
  const trussFactor = {
    warren: 1.0,
    pratt: 1.1,
    long: 1.25,
    modular: 0.9,
  }[configuration.trussType] || 1.0;
  const coatingAdj = subModifiers?.coating === 'weathering' ? 0.98 : 1.0; // tiny difference

  // Provisional load multiplier used for weight - placeholder until engineering provides precise adjustments
  const loadWeightMultMap = {
    '10k': 1.00,
    '25k': 1.06,
    'cl625': 1.15,
    '126k': 1.25
  };
  const loadWMult = loadWeightMultMap[(subModifiers?.loadRating) || '10k'] || 1.0;
  const WEIGHT_CAL_FACTOR = 1/3; // temporary calibration to correct ~3x overestimate across the board
  const structureWeight = (STRUCTURE_BASE_PSF * area * materialFactor * trussFactor * coatingAdj * loadWMult) * WEIGHT_CAL_FACTOR;

  // Decking weights (psf)
  const deckingPsf = {
    concrete: 50,
    asphalt: 25,
    wood: 8,
    steel: 12,
  }[decking] || 35;
  let deckWeight = (deckingPsf * area) * WEIGHT_CAL_FACTOR;

  // Railing weight
  const perimeter = (length * 2) + (width > 8 ? width * 2 : 0);
  const railingPlf = {
    cable: 5,
    vertical: 9,
    horizontal: 8,
    glass: 14,
  }[railing] || 8;
  let railingWeight = (railingPlf * perimeter) * WEIGHT_CAL_FACTOR;
  if (railing === 'vertical' && subModifiers?.picketStyle === 'spear-top') {
    railingWeight *= 1.05; // a bit more for spear caps
  }

  // Add-ons weight (very rough)
  let addOnsWeight = 0; // will apply calibration at the end for consistency
  if (addOns?.includes('led-lighting')) addOnsWeight += 300; // drivers, housings, etc.
  if (addOns?.includes('safety-barriers')) addOnsWeight += (2 * length) * 25; // both sides, lb/ft
  if (addOns?.includes('weather-protection')) addOnsWeight += area * 2; // canopy panels, lb/sf
  if (addOns?.includes('monitoring-system')) addOnsWeight += 150; // sensors, cabling

  // Decorative steel add-ons
  if (subModifiers?.steelDecor?.length) {
    subModifiers.steelDecor.forEach(id => {
      if (id === 'finials') addOnsWeight += 200;
      if (id === 'lattice') addOnsWeight += (2 * length) * 2; // lb/ft along both sides
      if (id === 'nameplate') addOnsWeight += 80;
    });
  }

  // Wingwalls weight (excluded from bridge total; shown separately)
  let wingwallsWeight = 0;
  if (subModifiers?.wingwalls && subModifiers.wingwalls !== 'none') {
    const perFootWidth = {
      'concrete-angled': 300,
      'stone': 450,
      'steel-sheet': 220,
    }[subModifiers.wingwalls] || 0;
    wingwallsWeight = perFootWidth * width * 2; // both abutments
  }

  // Apply calibration to add-ons as well
  addOnsWeight *= WEIGHT_CAL_FACTOR;

  const totalWeight = Math.max(0, structureWeight + deckWeight + railingWeight + addOnsWeight);

  return {
    structureWeight: Math.round(structureWeight),
    deckWeight: Math.round(deckWeight),
    railingWeight: Math.round(railingWeight),
    addOnsWeight: Math.round(addOnsWeight),
    wingwallsWeight: Math.round(wingwallsWeight), // not included in total
    totalWeight: Math.round(totalWeight)
  };
};